import { StatusColorCase } from '@/interfaces';

export const getCaseStatusColor = (progressName: string): StatusColorCase => {
	switch (progressName) {
		case 'Case Not Started':
			return 'gray';
		case 'In Progress':
			return 'green';
		case 'Action Required':
			return 'red';
		case 'Resolved Case':
			return 'check';
		case 'Case Unsuccessful':
		case 'Case Aborted':
			return 'x';
		default:
			return 'gray';
	}
};
